/**
 * 說明 : 梯控裝置資料與後端API調用的非同步行為
 */
import {createAsyncThunk} from '@reduxjs/toolkit';

import BaseAPI from './BaseAPI';

// 新增梯控裝置
export const addControlDevice = createAsyncThunk(
  'controlDevice/addControlDevice',
  async (controlDevice, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.postWithAuth('/setting/controlDevice', controlDevice, token);
      return data;
    } catch (err) {
      console.error('add control device error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 修改梯控裝置
export const editControlDevice = createAsyncThunk(
  'controlDevice/editControlDevice',
  async (controlDevice, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.putWithAuth('/setting/controlDevice', controlDevice, token);
      return data;
    } catch (err) {
      console.error('edit control device error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 修改梯控裝置狀態
export const editControlDeviceStatus = createAsyncThunk(
  'controlDevice/editControlDeviceStatus',
  async ({deviceId, status}, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.putWithAuth('/setting/controlDevice/status', {deviceId: deviceId, flgStatus: status}, token);
      return data;
    } catch (err) {
      console.error('update control device status error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 刪除梯控裝置
export const deleteControlDevice = createAsyncThunk(
  'controlDevice/deleteControlDevice',
  async (deviceId, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.deleteWithAuth(`/setting/controlDevice/${deviceId}`, null, token);
      return data;
    } catch (err) {
      console.error('delete control device error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 取得單筆梯控裝置資料
export const fetchControlDevice = createAsyncThunk(
  'controlDevice/fetchControlDevice',
  async (deviceId, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.getWithAuth(`/setting/controlDevice/${deviceId}`, null, token);
      return data;
    } catch (err) {
      console.error('fetch control device error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 取得梯控裝置清單列表
export const fetchControlDeviceList = createAsyncThunk(
  'controlDevice/fetchControlDeviceList',
  async ({buildingId}, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.getWithAuth('/setting/controlDevice', {buildingId: buildingId}, token);
      return data;
    } catch (err) {
      console.error('fetch control device list error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 同步梯控裝置Mac Address
export const syncControlDeviceMac = createAsyncThunk(
  'controlDevice/syncControlDeviceMac',
  async ({hostname}, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.putWithAuth('/setting/controlDevice/syncMac', {hostname: hostname}, token);
      return data;
    } catch (err) {
      console.error('sync control device mac error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);
